/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  mainLabel: 'mainLabel',
  travelDetailsInfo: 'travelDetailsInfo',
  button: {
    close: 'button.close',
    send: 'button.send',
    bookHere: 'button.bookHere',
    clickHere: 'button.clickHere',
    set: 'button.set'
  },
  messages: { error: 'messages.error', success: 'messages.success' }
}; export default Keys;